import { render, staticRenderFns } from "./SidenavHeader.vue?vue&type=template&id=90af4b86&"
import script from "./SidenavHeader.vue?vue&type=script&lang=js&"
export * from "./SidenavHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90af4b86')) {
      api.createRecord('90af4b86', component.options)
    } else {
      api.reload('90af4b86', component.options)
    }
    module.hot.accept("./SidenavHeader.vue?vue&type=template&id=90af4b86&", function () {
      api.rerender('90af4b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/vendor/libs/sidenav/SidenavHeader.vue"
export default component.exports